import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import { ServerTable, Event } from 'vue-tables-2';
import Notifications from 'vue-notification'
import vuexI18n from 'vuex-i18n'
import { messages } from './locale'
import './style/style.scss'
import { tokenHandler } from '@/client'
import { ModalPlugin } from './plugins/modal'
Vue.use(ModalPlugin)

Vue.use(Notifications)

var $ = require('jquery');
window.$ = $;
require('bootstrap');
Vue.use(ServerTable, {})
Vue.use(Event)
Vue.config.productionTip = false
Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('fi', messages.fi)
Vue.i18n.add('en', messages.en)
Vue.i18n.add('sv', messages.sv)
Vue.i18n.add('svfi', messages.svfi)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});
Vue.i18n.set('fi')
Vue.use(VueResource)
Vue.use(tokenHandler, { store })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
